export const getSessionId = (): string | null => {
  const metaTag = document.querySelector('meta[name="session-id"]');
  return metaTag?.getAttribute('content') ?? null;
};
